{
  "addons.addonList": "Add-on-Liste",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "API-Key über diesen Link erhalten",
  "addons.ambientWeatherDescription": "Ambient-Wetterstationen (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API-Schlüssel",
  "addons.applicationKey": "Anwendungs-Schlüssel",
  "addons.connect": "Verbinden",
  "addons.davisApiSecret": "API-Secret",
  "addons.davisApiV2Key": "V2 API-Schlüssel",
  "addons.davisDescription": "Davis Wetterstationen (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Rufen Sie Ihre V2-API-Schlüssel über diesen Link ab",
  "addons.disconnect": "Trennen",
  "addons.ecowittCreateAndRetrieveKeys": "Erstellen Sie Ihren API- und App-Schlüssel und rufen Sie ihn über diesen Link ab",
  "addons.ecowittDescription": "Ecowitt bietet professionelle Wetterstationen, kabellose Innen-/Außenthermometer, hochpräzise Regenmesser, Luftqualitätssensoren und vieles mehr.",
  "addons.helpLink": "So verbinden Sie {provider}",
  "addons.myAcuriteAccountOnHold": "Ihr Konto wurde gesperrt. Bitte geben Sie Ihr Passwort ein, um Ihr Konto erneut zu verbinden",
  "addons.myAcuriteDescription": "AcuRite ist die führende Marke für Wetterstationen in Nordamerika. Als führender Anbieter von Zeit-, Temperatur- und Wettertechnologie stellt Ihnen AcuRite detaillierte Informationen über Ihre Innen- und Außenumgebung zur Verfügung, damit Sie Ihren Tag sicher planen können.",
  "addons.myAcuriteEnterCredentials": "Geben Sie Ihre My AcuRite-Anmeldeinformationen ein, um Ihr My AcuRite-Konto mit SmartMixin zu verknüpfen",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Verwenden Sie Ihren Netatmo-Thermostat, um die Temperatur Ihres Hauses von Ihrem Bett oder von überall auf der Welt zu ändern.",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Verwalte die Messwerte auf dem eigenen Smartphone.",
  "addons.or": "oder",
  "addons.providerAccountDisconnected": "Die Verbindung zu Ihrem Wetterdienst ist abgelaufen. Bitte verbinden Sie sich erneut, um die Datenaktualisierungen fortzusetzen.",
  "addons.reconnect": "Erneut verbinden",
  "addons.weatherflowCreateToken": "Erstellen Sie Ihr Token und rufen Sie es über diesen Link ab",
  "addons.weatherflowTempestDescription": "Tempest Wettersystem mit integriertem Windmesser, Regenmesser",
  "addons.wundergroundApiKey": "API-Schlüssel",
  "addons.wundergroundDescription": "Weather Underground ist eine globale Gemeinschaft von Menschen, die Daten von Umweltsensoren wie Wetterstationen und Luftqualitätsmonitoren miteinander verbinden, damit wir die reichhaltigen, hyperlokalen Daten bereitstellen können, die Sie benötigen, um Ihre Leidenschaften zu fördern",
  "addons.wundergroundRetrieveApiKey": "Rufen Sie Ihren API-Schlüssel über diesen Link ab",
  "addons.wundergroundRetrieveStationId": "Rufen Sie Ihre Station ID über diesen Link ab",
  "addons.wundergroundStationId": "Stations-ID",
  "airQuality.airQuality": "Luftqualität",
  "airQuality.airQualityIndex": "Index Luftqualität",
  "airQuality.co": "Kohlenmonoxid",
  "airQuality.good": "Gut",
  "airQuality.goodDescription": "Die Qualität der Luft ist zufriedenstellend. Die Luftverschmutzung stellt ein geringes oder kein Risiko dar.",
  "airQuality.hazardous": "Gesundheitsgefährdend",
  "airQuality.hazardousDescription": "Gesundheitsalarm: Jeder könnte ernstere Auswirkungen auf die Gesundheit verspüren",
  "airQuality.indoorAirQuality": "Innenraum Luftqualität",
  "airQuality.moderate": "Mäßig",
  "airQuality.moderateDescription": "Die Luftqualität ist insgesamt akzeptabel. Bei manchen Schadstoffen bestehen jedoch für einen sehr kleinen Personenkreis, der außergewöhnlich empfindlich auf Luftverschmutzung reagiert, eventuell Gesundheitsbedenken.",
  "airQuality.no2": "Stickstoffdioxid",
  "airQuality.o3": "Ozon",
  "airQuality.pm10": "Partikel mit einem Durchmesser von 10 μm oder weniger",
  "airQuality.pm25": "Partikel mit einem Durchmesser von 2.5 μm oder weniger",
  "airQuality.sensitiveUnhealthy": "Ungesund für empfindliche Personengruppen",
  "airQuality.sensitiveUnhealthyDescription": "Bei empfindlichen Personengruppen können gesundheitliche Auswirkungen auftreten. Die allgemeine Öffentlichkeit ist höchstwahrscheinlich nicht betroffen.",
  "airQuality.so2": "Schwefeldioxid",
  "airQuality.unhealthy": "Ungesund",
  "airQuality.unhealthyDescription": "Erste gesundheitliche Auswirkungen können sich bei allen Personengruppen einstellen. Bei empfindlichen Personengruppen können ernstere gesundheitliche Auswirkungen auftreten.",
  "airQuality.veryUnhealthy": "Sehr ungesund",
  "airQuality.veryUnhealthyDezscription": "Gesundheitswarnung aufgrund einer Notfallsituation. Die gesamte Bevölkerung ist voraussichtlich betroffen.",
  "alerts.addAlert": "Alarm hinzufügen",
  "alerts.addCondition": "Bedingung hinzufügen",
  "alerts.alertAdded": "Alert erfolgreich hinzugefügt",
  "alerts.alertAuthorizationNotice": "Alerts funktionieren nur, wenn Sie SmartMixin autorisieren, Benachrichtigungen anzuzeigen",
  "alerts.alertDeleted": "Warnung erfolgreich gelöscht",
  "alerts.alertEdited": "Benachrichtigung erfolgreich geändert",
  "alerts.alertName": "Name der Benachrichtigung",
  "alerts.alertWhen": "Ich möchte benachrichtigt werden, wenn:",
  "alerts.aqiGreaterThan": "AQI größer als",
  "alerts.aqiGreaterThanThreshold": "AQI größer als {value}{unit} Schwellenwert",
  "alerts.aqiLessThan": "AQI kleiner als",
  "alerts.aqiLessThanThreshold": "AQI kleiner als {value}{unit} Schwellenwert",
  "alerts.atLeastOneCondition": "Sie müssen mindestens eine Bedingung hinzufügen",
  "alerts.co2GreaterThan": "CO2 größer als",
  "alerts.co2GreaterThanThreshold": "CO2 größer als {value}{unit} Schwellenwert",
  "alerts.co2LessThan": "CO2 kleiner als",
  "alerts.co2LessThanThreshold": "CO2 kleiner als {value}{unit} Schwellenwert",
  "alerts.conditions": "Bedingungen",
  "alerts.createAlert": "Alarm hinzufügen",
  "alerts.dailyPrecipitationGreaterThan": "Tagesniederschlag größer als",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Tagesniederschlag über dem Schwellenwert von {value}{unit}",
  "alerts.deleteAlert": "Alarm löschen",
  "alerts.editAlert": "Alarm bearbeiten",
  "alerts.editCondition": "Bedingung bearbeiten",
  "alerts.gustSpeedGreaterThan": "Böengeschwindigkeit größer als",
  "alerts.gustSpeedGreaterThanThreshold": "Böengeschwindigkeit größer als {value}{unit} Schwellenwert",
  "alerts.gustSpeedLessThan": "Böengeschwindigkeit kleiner als",
  "alerts.gustSpeedLessThanThreshold": "Böengeschwindigkeit kleiner als {value}{unit} Schwellenwert",
  "alerts.heatIndexGreaterThan": "Hitze-Index größer als",
  "alerts.heatIndexGreaterThanThreshold": "Hitze-Index größer als {value}{unit} Schwellenwert",
  "alerts.heatIndexLessThan": "Hitze-Index kleiner als",
  "alerts.heatIndexLessThanThreshold": "Hitze-Index kleiner als {value}{unit} Schwellenwert",
  "alerts.humidexGreaterThan": "Humidex größer als",
  "alerts.humidexGreaterThanThreshold": "Humidex größer als {value}{unit} Schwellenwert",
  "alerts.humidexLessThan": "Humidex kleiner als",
  "alerts.humidexLessThanThreshold": "Humidex kleiner als {value}{unit} Schwellenwert",
  "alerts.humidityGreaterThan": "Luftfeuchtigkeit größer als",
  "alerts.humidityGreaterThanThreshold": "Luftfeuchtigkeit größer als {value}{unit} Schwellenwert",
  "alerts.humidityLessThan": "Luftfeuchtigkeit kleiner als",
  "alerts.humidityLessThanThreshold": "Luftfeuchtigkeit kleiner als {value}{unit} Schwellenwert",
  "alerts.inProgress": "In Bearbeitung",
  "alerts.myAlerts": "Meine Alarme",
  "alerts.noConfiguredAlert": "Sie haben noch keine Alarme konfiguriert, fangen Sie an, einen hinzuzufügen",
  "alerts.noiseGreaterThan": "Lärm größer als",
  "alerts.noiseGreaterThanThreshold": "Lärm größer als {value}{unit} Schwellenwert",
  "alerts.noiseLessThan": "Lärm kleiner als",
  "alerts.noiseLessThanThreshold": "Lärm kleiner als {value}{unit} Schwellenwert",
  "alerts.noteOnConditions": "Beachten Sie, dass der Alarm ausgelöst wird, wenn alle der folgenden Bedingungen erfüllt sind",
  "alerts.pm10GreaterThan": "PM 10 größer als",
  "alerts.pm10GreaterThanThreshold": "PM 10 größer als {value}{unit} Schwellenwert",
  "alerts.pm10LessThan": "PM 10 kleiner als",
  "alerts.pm10LessThanThreshold": "PM 10 weniger als {value}{unit} Schwellenwert",
  "alerts.pm1GreaterThan": "PM 1 größer als",
  "alerts.pm1GreaterThanThreshold": "PM 1 größer als {value}{unit} Grenzwert",
  "alerts.pm1LessThan": "PM 1 kleiner als",
  "alerts.pm1LessThanThreshold": "PM 1 weniger als {value}{unit} Grenzwert",
  "alerts.pm2p5GreaterThan": "PM 2,5 größer als",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 größer als {value}{unit} Grenzwert",
  "alerts.pm2p5LessThan": "PM 2,5 kleiner als",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 weniger als {value}{unit} Schwellenwert",
  "alerts.postStormSummary": "Regenereignis-Zusammenfassung",
  "alerts.postStormSynopsisHelper": "Sie erhalten nach jedem Regenereignis eine zusammenfassende Benachrichtigung.",
  "alerts.postStormSynopsisSoleCondition": "Eine Zusammenfassung nach dem Sturm kann nicht mit anderen Bedingungen kombiniert werden.",
  "alerts.precipitationGreaterThan": "Stündlicher Niederschlag größer als",
  "alerts.precipitationGreaterThanThreshold": "Stündlicher Niederschlag über dem Schwellenwert von {value}{unit}",
  "alerts.pressureGreaterThan": "Druck größer als",
  "alerts.pressureGreaterThanThreshold": "Druck größer als {value}{unit} Grenzwert",
  "alerts.pressureLessThan": "Druck kleiner als",
  "alerts.pressureLessThanThreshold": "Druck kleiner als {value}{unit} Schwellenwert",
  "alerts.rainRateGreaterThan": "Regenrate größer als",
  "alerts.rainRateGreaterThanThreshold": "Regenrate über dem Schwellenwert von {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Sonneneinstrahlung größer als",
  "alerts.solarRadiationGreaterThanThreshold": "Sonneneinstrahlung größer als {value}{unit} Schwellenwert",
  "alerts.solarRadiationLessThan": "Sonneneinstrahlung kleiner als",
  "alerts.solarRadiationLessThanThreshold": "Sonneneinstrahlung kleiner als {value}{unit} Schwellenwert",
  "alerts.temperatureGreaterThan": "Temperatur größer als",
  "alerts.temperatureGreaterThanThreshold": "Temperatur größer als {value}{unit} Schwellenwert",
  "alerts.temperatureLessThan": "Temperatur kleiner als",
  "alerts.temperatureLessThanThreshold": "Temperatur kleiner als {value}{unit} Schwellenwert",
  "alerts.thswGreaterThan": "THSW größer als",
  "alerts.thswGreaterThanThreshold": "THSW größer als {value}{unit} Schwellenwert",
  "alerts.thswLessThan": "THSW kleiner als",
  "alerts.thswLessThanThreshold": "THSW kleiner als {value}{unit} Schwellenwert",
  "alerts.thwGreaterThan": "THW größer als",
  "alerts.thwGreaterThanThreshold": "THW größer als {value}{unit} Schwellenwert",
  "alerts.thwLessThan": "THW kleiner als",
  "alerts.thwLessThanThreshold": "THW kleiner als {value}{unit} Schwellenwert",
  "alerts.uvGreaterThan": "UV-Index größer als",
  "alerts.uvGreaterThanThreshold": "UV-Index größer als {value}{unit} Schwellenwert",
  "alerts.uvLessThan": "UV-Index kleiner als",
  "alerts.uvLessThanThreshold": "UV-Index kleiner als {value}{unit} Schwellenwert",
  "alerts.visibilityGreaterThanThreshold": "Sichtbarkeit größer als {value}{unit} Schwellenwert",
  "alerts.visibilityLessThanThreshold": "Sichtbarkeit kleiner als {value}{unit} Schwellenwert",
  "alerts.visiblityGreaterThan": "Sichtbarkeit größer als",
  "alerts.visiblityLessThan": "Sichtbarkeit kleiner als",
  "alerts.whichMeasure": "Für welche Maßnahme möchten Sie gewarnt werden?",
  "alerts.whichModule": "Für welches Modul möchten Sie alarmiert werden?",
  "alerts.windChillGreaterThan": "Windchill größer als",
  "alerts.windChillGreaterThanThreshold": "Windchill größer als {value}{unit} Schwellenwert",
  "alerts.windChillLessThan": "Windchill kleiner als",
  "alerts.windChillLessThanThreshold": "Windchill kleiner als {value}{unit} Schwellenwert",
  "alerts.windSpeedGreaterThan": "Windgeschwindigkeit größer als",
  "alerts.windSpeedGreaterThanThreshold": "Windgeschwindigkeit größer als {value}{unit} Schwellenwert",
  "alerts.windSpeedLessThan": "Windgeschwindigkeit kleiner als",
  "alerts.windSpeedLessThanThreshold": "Windgeschwindigkeit kleiner als {value}{unit} Schwellenwert",
  "astral.astronomicalSunPhase": "Astronomisch {sunPhase}",
  "astral.civilSunPhase": "Bürgerlich {sunPhase}",
  "astral.dawn": "Morgendämmerung",
  "astral.dusk": "Abenddämmerung",
  "astral.firstQuarter": "Erstes Viertel",
  "astral.fullMoon": "Vollmond",
  "astral.lastQuarter": "Letztes Viertel",
  "astral.moon": "Mond",
  "astral.moonPhases": "Mondphasen",
  "astral.moonrise": "Mondaufgang",
  "astral.moonset": "Monduntergang",
  "astral.nauticalSunPhase": "Nautisch {sunPhase}",
  "astral.newMoon": "Neumond",
  "astral.noon": "Mittagszeit",
  "astral.remainingDaylight": "verbleibende Zeit für Tageslicht",
  "astral.sunrise": "Sonnenaufgang",
  "astral.sunriseAndSunset": "Sonnenaufgang und Sonnenuntergang",
  "astral.sunriseAt": "Sonnenaufgang um {time}",
  "astral.sunset": "Sonnenuntergang",
  "astral.sunsetAt": "Sonnenuntergang um {time}",
  "astral.totalDaylight": "gesamtes Tageslicht",
  "astral.waningCrescent": "Abnehmende Mondsichel",
  "astral.waningGibbous": "Abnehmender Dreiviertelmond",
  "astral.waxingCrescent": "Wachsende Mondsichel",
  "astral.waxingGibbous": "Zunehmender Dreiviertelmond",
  "auth.alreadyHaveAccount": "Haben Sie bereits ein Konto?",
  "auth.authContainerTagline": "Ihr persönliches Wetter-Dashboard. Verbinden Sie Ihre Stationen und erhalten Sie Echtzeitdaten auf einen Blick.",
  "auth.backToLogin": "Zurück zum Login",
  "auth.catchPhrase": "Die Weather Intelligence Platform",
  "auth.checkYourEmail": "Überprüfen Sie Ihre E-Mail",
  "auth.continueWithApple": "Mit Apple fortfahren",
  "auth.continueWithFacebook": "Mit Facebook fortfahren",
  "auth.continueWithGoogle": "Mit Google fortfahren",
  "auth.email": "EMail-Adresse",
  "auth.emailRequiredLoginFacebook": "Bestätigung per E-Mail ist notwendig.",
  "auth.emailVerification": "E-Mail-Verifizierung",
  "auth.emailVerificationFailure": "Während der E-Mail-Überprüfung ist ein Fehler aufgetreten.",
  "auth.emailVerificationSuccess": "Ihre E-Mail-Adresse wurde erfolgreich überprüft.",
  "auth.firstName": "Vorname",
  "auth.forgotPassword": "Passwort vergessen",
  "auth.forgotPasswordSubtitle": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
  "auth.lastName": "Nachname",
  "auth.login": "Login",
  "auth.loginSubtitle": "Willkommen zurück! Bitte geben Sie Ihre Daten ein.",
  "auth.loginToSmartMixinDescription": "Geben Sie Ihre SmartMixin-Anmeldeinformationen ein, um auf Ihr Konto zuzugreifen.",
  "auth.logout": "Ausloggen",
  "auth.logoutConfirmation": "Wirklich ausloggen?",
  "auth.noAccountYet": "Haben Sie noch kein Konto?",
  "auth.or": "oder",
  "auth.password": "Passwort",
  "auth.passwordAgain": "Passwort wiederholen",
  "auth.passwordReset": "Passwort wiederherstellen",
  "auth.passwordResetSuccess": "Wiederherstellung des Passworts erfolgreich.",
  "auth.register": "Registrieren",
  "auth.registerDescription": "Erstellen Sie ein kostenloses SmartMixin-Konto, um Ihre Wetterstationen zu verbinden, Wetterdaten zu verfolgen und auf leistungsstarke Analysetools zuzugreifen.",
  "auth.registerSubtitle": "Erstellen Sie Ihr Konto, um loszulegen.",
  "auth.registerSuccess": "Sie haben sich erfolgreich registriert! Wir haben Ihnen gerade einen Bestätigungslink unter {emailAddress} mit weiteren Anweisungen gesendet.",
  "auth.restorePassword": "Passwort wiederherstellen",
  "auth.restorePasswordSuccess": "Wir haben Ihnen gerade einen Link zum Zurücksetzen des Passworts unter {emailAddress} mit weiteren Anweisungen gesendet.",
  "auth.sendReset": "Anweisungen zum Zurücksetzen senden",
  "auth.socialAccount": "oder verwenden Sie Ihr Konto",
  "auth.welcome": "Willkommen bei SmartMixin",
  "auth.welcomeBack": "Willkommen zurück!",
  "calendar.april": "April",
  "calendar.august": "August",
  "calendar.dateFormat": "Datumsformat",
  "calendar.day": "Tag",
  "calendar.december": "Dezember",
  "calendar.end": "Ende",
  "calendar.february": "Februar",
  "calendar.hours": "Stunden",
  "calendar.hoursShort": "Std.",
  "calendar.january": "Januar",
  "calendar.july": "Juli",
  "calendar.june": "Juni",
  "calendar.last24Hours": "Letzte 24 Stunden",
  "calendar.last30Days": "Letzte 30 Tage",
  "calendar.last7Days": "Letzte 7 Tage",
  "calendar.march": "März",
  "calendar.max": "Max",
  "calendar.may": "Mai",
  "calendar.month": "Monat",
  "calendar.months": "Monate",
  "calendar.november": "November",
  "calendar.october": "Oktober",
  "calendar.oneDay": "1 Tag",
  "calendar.oneHour": "1 Stunde",
  "calendar.oneMonth": "1 Monat",
  "calendar.oneWeek": "1 Woche",
  "calendar.previous24Hours": "Vorherige 24 Stunden",
  "calendar.previous30Days": "Vorherige 30 Tage",
  "calendar.previous7Days": "Vorherige 7 Tage",
  "calendar.previousDay": "Vorheriger Tag",
  "calendar.previousMonth": "Vorheriger Monat",
  "calendar.previousWeek": "Vorherige Woche",
  "calendar.previousYear": "Vorheriges Jahr",
  "calendar.sameDayLastYear": "Gleiches Datum im Vorjahr",
  "calendar.sameMonthLastYear": "Gleicher Monat im Vorjahr",
  "calendar.selectADate": "Wählen Sie ein Datum",
  "calendar.selectAMonth": "Wählen Sie einen Monat",
  "calendar.selectAYear": "Wählen Sie ein Jahr",
  "calendar.selectGranularity": "Granularität auswählen",
  "calendar.selectTimescale": "Zeitskala auswählen",
  "calendar.september": "September",
  "calendar.sixHours": "6 Stunden",
  "calendar.start": "Anfang",
  "calendar.thirtyMinutes": "30-Min",
  "calendar.threeHours": "3 Stunden",
  "calendar.use24HourFormat": "24-Stunden-Format verwenden",
  "calendar.week": "Woche",
  "calendar.year": "Jahr",
  "calendar.yesterday": "Gestern",
  "common.accountDeleted": "Der Account wurde erfolgreich gelöscht",
  "common.accountOnHold": "Ihre Kontoverbindung ist abgelaufen. Bitte verbinden Sie sich erneut, um die Datenaktualisierungen fortzusetzen.",
  "common.add": "hinzufügen",
  "common.addAStation": "Station hinzufügen",
  "common.addToFavorites": "Zu Favoriten hinzufügen",
  "common.addYourOwnStation": "Station hinzufügen",
  "common.alreadyPremium": "Sie haben bereits ein Premium-Konto!",
  "common.alsoAvailableOn": "Auch verfügbar auf:",
  "common.altitude": "Höhe",
  "common.analysis": "Auswertung",
  "common.aroundMe": "In der Nähe",
  "common.articleCount": "{count, plural, one {count} Artikel} other {count} Artikel}}",
  "common.articleNotFound": "Artikel nicht gefunden",
  "common.articleNotFoundDescription": "Der gesuchte Artikel existiert nicht.",
  "common.average": "Durchschnitt",
  "common.averageOverThePeriod": "Durchschnitt über den Zeitraum",
  "common.away": "Unterwegs",
  "common.back": "Zurück",
  "common.backToHelpCenter": "Zurück zum Hilfecenter",
  "common.backToHome": "Zurück zur Startseite",
  "common.bad": "Schlecht",
  "common.batteryLevel": "Batteriestand",
  "common.bestValue": "Bester Wert",
  "common.billingDetailsAndroid": "Für ein kostenloses Testangebot werden Ihnen keine Gebühren berechnet, wenn Sie 24 Stunden vor Ablauf der kostenlosen Einführungsphase kündigen. Wenn die Testphase beendet ist, können Sie das SmartMixin-Abonnement jederzeit über die Einstellungen Ihres Google Play-Kontos zum Ende des Abo-Zeitraums kündigen. Dies muss 24 Stunden vor dem Ende des Abonnementzeitraums erfolgen, um zu vermeiden, dass eine weitere Gebühr berechnet wird, die in der obigen Schaltfläche angegeben ist. Abonnementzahlungen werden Ihrem Google Play-Konto bei Bestätigung Ihres Kaufs und zu Beginn jedes Kaufs belastet.",
  "common.billingDetailsIos": "Für ein kostenloses Testangebot werden Ihnen keine Gebühren berechnet, wenn Sie 24 Stunden vor Ablauf der kostenlosen Einführungsphase kündigen. Wenn die Testphase beendet ist, können Sie das SmartMixin-Abonnement jederzeit über die Einstellungen Ihres App Store-Kontos zum Ende des Abo-Zeitraums kündigen. Dies muss 24 Stunden vor dem Ende des Abonnementzeitraums erfolgen, um zu vermeiden, dass eine weitere Gebühr berechnet wird, die in der obigen Schaltfläche angegeben ist. Abonnementzahlungen werden Ihrem App Store-Konto bei Bestätigung Ihres Kaufs und zu Beginn jedes Kaufs belastet.",
  "common.boilerOn": "Heizung EIN",
  "common.browseByCategory": "Nach Kategorie durchsuchen",
  "common.calendarView": "Kalenderansicht",
  "common.cancel": "Abbrechen",
  "common.cannotBeEmpty": "Dieses Feld darf nicht leer sein.",
  "common.cardDetails": "Kartendetails",
  "common.categoryNotFound": "Kategorie nicht gefunden",
  "common.categoryNotFoundDescription": "Diese Kategorie existiert nicht oder enthält keine Artikel.",
  "common.charts": "Diagramme",
  "common.chartView": "Diagrammansicht",
  "common.clearRecentLocations": "Alle klar",
  "common.close": "Schließen",
  "common.comparison": "Vergleich",
  "common.currentDay": "Aktueller Tag",
  "common.currentLocation": "Aktueller Standort",
  "common.currentObservations": "Aktuelle Beobachtung",
  "common.currentRainEvent": "Aktueller Niederschlag",
  "common.currentRate": "Aktuelle Rate",
  "common.currentWeatherConditions": "Aktuelle Bedingungen",
  "common.customizeComparisonMetrics": "Vergleichsmetriken anpassen",
  "common.customizeComparisonMetricsDescription": "Ziehen Sie Elemente, um Ihre Vergleichsmetriken neu anzuordnen. Tippen Sie auf das Augensymbol, um Metriken ein- oder auszublenden.",
  "common.customizeDashboard": "Anpassen",
  "common.customizeDashboardDescription": "Ziehen Sie Elemente, um Ihr Dashboard neu anzuordnen. Tippen Sie auf das Augensymbol, um Bereiche ein- oder auszublenden.",
  "common.customizedStationName": "Benutzerdefinierter Sendername",
  "common.dailyForecast": "Tägliche Vorhersage",
  "common.dashboard": "Übersicht",
  "common.default": "Standard",
  "common.defaultForecastModelChip": "Standard · {name}",
  "common.delete": "Löschen",
  "common.deleteAccount": "Account löschen",
  "common.deleteAccountConfirmation": "Sicher, dass der Account gelöscht werden soll? Der Vorgang ist unwiderruflich.",
  "common.deleteAccountDescription": "Durch diese Aktion werden Ihr Konto und alle Ihre Informationen gelöscht. Es gibt kein Zurück.",
  "common.details": "Details",
  "common.edit": "Bearbeiten",
  "common.editor": "Editor",
  "common.endTime": "Ende Zeit",
  "common.exitFullscreen": "Vollbild beenden",
  "common.exploreWeatherMap": "Wetterkarte Erkunden",
  "common.favoriteLocations": "Favoriten",
  "common.favoriteLocationsEmpty": "Sie können bis zu 5 Lieblingsorten hinzufügen.",
  "common.favoriteStations": "Stationen auf Favoriten-Liste",
  "common.feedbackHelpsImprove": "Ihre Rückmeldung hilft uns, unsere Hilfeartikel zu verbessern.",
  "common.filterStationDescription": "Zeigen Sie keine Stationen mit unzuverlässigen Messungen an.",
  "common.filterStations": "Stationen filtern",
  "common.filterStationSourceDescription": "Wählen Sie Senderanbieter aus, die Sie auf der Karte anzeigen möchten",
  "common.findStationsNearYou": "Stationen in Ihrer Nähe finden",
  "common.firmwareVersion": "Firmware-Version",
  "common.forecast": "Vorhersage",
  "common.forecastComparisonDescription": "Einfacher Vergleich der Vorhersagen verschiedener Quellen",
  "common.forecastModelComparison": "Vorhersagen Vergleich",
  "common.forecastModelCoverage": "Abdeckung",
  "common.forecastModelDescription": "Beschreibung",
  "common.forecastModelDescription_AROME": "Météo Frances konvektionsauflösendes hochauflösendes Modell über Westeuropa mit 1,3 km Auflösung. Bestklassig für kurzfristige Vorhersagen in Frankreich; alle drei Stunden aktualisiert.",
  "common.forecastModelDescription_ARPEGE_EU": "Météo Frances europäisches Nest des ARPEGE-Modells mit 10 km Auflösung. Mittelfristige Vorhersagen über Europa, viermal täglich aktualisiert.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Météo Frances globales numerisches Wettermodell mit 25 km Auflösung, läuft bis etwa 4 Tage. Viermal täglich aktualisiert.",
  "common.forecastModelDescription_EC_GDPS": "Environment Canadas Global Deterministic Prediction System: ein weltweites mittelfristiges Modell mit 15 km Auflösung, das bis zu 10 Tage läuft, zweimal täglich aktualisiert.",
  "common.forecastModelDescription_EC_RDPS": "Environment Canadas Regional Deterministic Prediction System: ein mittelfristiges Modell über Nordamerika mit 10 km Auflösung, viermal täglich aktualisiert.",
  "common.forecastModelDescription_GFS": "NOAAs Flaggschiff-Globalmodell mittlerer Reichweite. Deckt den gesamten Planeten mit 25 km Auflösung bis zu 16 Tage ab, viermal täglich aktualisiert.",
  "common.forecastModelDescription_HRRR_CONUS": "NOAAs High-Resolution Rapid Refresh: ein konvektionsauflösendes Modell über die kontinentalen Vereinigten Staaten mit 3 km Auflösung, stündlich aktualisiert. Am besten geeignet für sehr kurzfristige Vorhersagen von Gewittern und extremem Wetter.",
  "common.forecastModelDescription_ICON_DE": "DWDs hochauflösendes konvektionsauflösendes Modell über Deutschland und Nachbarländer mit 2,2 km Auflösung. Kurzfristige Vorhersagen, zweimal täglich aktualisiert.",
  "common.forecastModelDescription_ICON_EU": "DWDs europäisches Nest des ICON-Modells mit 7 km Auflösung, das Europa und den Nordatlantik abdeckt. Mittelfristige Vorhersagen, viermal täglich aktualisiert.",
  "common.forecastModelDescription_MET_NORWAY": "Der offene Wettervorhersagedienst des Norwegischen Meteorologischen Instituts, der hochauflösende nordische Modelle mit ECMWF-Daten kombiniert, um weltweite Vorhersagen bis zu 10 Tagen im Voraus zu liefern.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "AROME-Nest über den französischen Antillen (Guadeloupe, Martinique) mit 2,5 km Auflösung. Kurzfristige Vorhersagen, viermal täglich aktualisiert.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "AROME-Nest über Französisch-Guayana mit 2,5 km Auflösung. Kurzfristige Vorhersagen, viermal täglich aktualisiert.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "AROME-Nest über Neukaledonien mit 2,5 km Auflösung. Kurzfristige Vorhersagen, viermal täglich aktualisiert.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "AROME-Nest über Französisch-Polynesien mit 2,5 km Auflösung. Kurzfristige Vorhersagen, viermal täglich aktualisiert.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "AROME-Nest über Réunion und Mayotte mit 2,5 km Auflösung. Kurzfristige Vorhersagen, viermal täglich aktualisiert.",
  "common.forecastModelDescription_NAM_CONUS": "NOAAs North American Mesoscale Modell Nest über die kontinentalen Vereinigten Staaten mit 5 km Auflösung. Kurzfristige Vorhersagen, viermal täglich aktualisiert.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "NOAAs North American Mesoscale Modell, das ganz Nordamerika mit 32 km Auflösung abdeckt. Viermal täglich aktualisiert.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Die Flaggschiff-Vorhersage von SmartMixin. Für jede Stunde an Ihrem Standort wählen wir das beste verfügbare Modell aus — typischerweise ein hochauflösendes regionales Modell, sofern vorhanden (AROME in Frankreich, ICON-D2 in Deutschland, HRRR in den USA, ARPEGE Europe auf dem Kontinent…) und greifen anderswo auf ein globales Modell zurück — dann füllen wir alle Lücken aus benachbarten Quellen. Das Ergebnis ist eine einzige nahtlose Vorhersage, die überall auf der Welt bis zu 14 Tage abdeckt, automatisch aktualisiert, wann immer eines der zugrunde liegenden Modelle aktualisiert wird.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Weatherflows proprietäre globale Vorhersage, die mehrere numerische Wettermodelle mit Beobachtungen aus seinem Tempest-Wetterstationsnetz kombiniert. 10-Tage-Horizont weltweit.",
  "common.forecastModelDetailTitle": "Vorhersagemodell",
  "common.forecastModelScopeGlobal": "Global",
  "common.forecastModelScopeGlobalDescription": "Dieses Modell deckt den gesamten Planeten ab.",
  "common.forecastModelScopeRegional": "Regional",
  "common.forecastModelScopeRegionalDescription": "Dieses Modell deckt nur eine bestimmte Region ab.",
  "common.forecastModelSpecifications": "Spezifikationen",
  "common.forecastSources": "Vorhersage Quellen",
  "common.freeAccount": "Kostenloses Konto",
  "common.freeSubscription": "Kostenloses Premium Abo",
  "common.freeTrialForPeriod": "Kostenlose Testversion für {period} Tage",
  "common.frequency": "Frequenz",
  "common.full": "Voll",
  "common.fullscreen": "Vollbild",
  "common.getStartedFree": "Kostenlos Starten",
  "common.getUnlimitedAccess": "Unbegrenzten Zugang zu:",
  "common.good": "Gut",
  "common.help": "Hilfe",
  "common.helpCategoryAccount": "Konto",
  "common.helpCategoryBilling": "Abrechnung",
  "common.helpCategoryGettingStarted": "Erste Schritte",
  "common.helpCategoryProviders": "Anbieter",
  "common.helpCategoryStations": "Stationen",
  "common.helpCategoryTroubleshooting": "Fehlerbehebung",
  "common.helpCenter": "Hilfecenter",
  "common.helpCenterDescription": "Finden Sie Antworten auf häufige Fragen und erfahren Sie, wie Sie SmartMixin optimal nutzen.",
  "common.hg": "Frostschutz",
  "common.hidden": "Ausgeblendet",
  "common.hiddenSensors": "Ausgeblendete Sensoren",
  "common.hiddenStations": "Versteckte Stationen",
  "common.hiddenStationsDescription": "Sie können eine Station entlasten, indem Sie das Augensymbol daneben tippen.",
  "common.high": "High",
  "common.home": "Home",
  "common.homeConnectService": "Besitzen Sie eine Wetterstation? Verbinden Sie Ihren Dienst",
  "common.homeInformation": "Home Information",
  "common.homeIntroduction": "Verbinden Sie Ihre externen Konten, um die SmartMixin-Funktionen zu nutzen.",
  "common.homeName": "Home Name",
  "common.homeSubtitle": "Ihr Wetter, alles an einem Ort",
  "common.horizon": "Horizont",
  "common.horizonValue": "bis zu {value} Stunden",
  "common.iDontKnowYet": "Ich weiß es noch nicht",
  "common.indoor": "Innen",
  "common.lastRainEvent": "Letzter Niederschlag",
  "common.lastUpdate": "Letztes Update",
  "common.legendLightningHelp": "Die Farbe zeigt das Alter jedes Blitzes der letzten {minutes} Minuten — die neuesten in Weiß, die ältesten in Dunkelrot.",
  "common.legendNewest": "Neueste",
  "common.legendOldest": "Älteste",
  "common.legendStationsHelp": "Die Markerfarbe entspricht dem Wert der ausgewählten Messgröße.",
  "common.lightningDataAttribution": "Blitzdaten: Blitzortung.org",
  "common.lightningStrikes": "Blitzeinschläge",
  "common.lightningStrikesDescription": "Blitzeinschläge in Echtzeit auf der Karte anzeigen",
  "common.loading": "Loading",
  "common.location": "Standort",
  "common.locationAddedToFavorites": "Standort zu Favoriten hinzugefügt",
  "common.locationNotGranted": "Die Standortgenehmigung wird nicht erteilt. Bitte ermöglichen Sie den Zugriff auf Ihren Standort in Geräteeinstellungen.",
  "common.locationRemovedFromFavorites": "Standort aus Favoriten entfernt",
  "common.locations": "Standorte",
  "common.low": "Niedrig",
  "common.manage": "Verwalten",
  "common.manageAccount": "Konto verwalten",
  "common.manageMySubscription": "Mein Abonnement verwalten",
  "common.manageSensors": "Sensoren verwalten",
  "common.manageSensorsDescription": "Ziehen Sie Elemente, um Sensoren neu anzuordnen. Tippen Sie auf das Augensymbol, um Sensoren ein- oder auszublenden. Tippen Sie auf einen Namen, um ihn umzubenennen.",
  "common.manualBoost": "Manual boost",
  "common.manualSetpointUntil": "Manueller Sollwert bis",
  "common.mapLayers": "Kartenebenen",
  "common.mapLegend": "Kartenlegende",
  "common.maxFavoriteLocationsReached": "Sie können nur bis zu 5 Lieblingsorte haben. Entfernen Sie einen, um einen anderen hinzuzufügen.",
  "common.measureToDisplay": "Zur Anzeige messen",
  "common.medium": "Medium",
  "common.meshSize": "Rastergröße",
  "common.minRead": "{minutes} Min. Lesezeit",
  "common.modifyFavoriteStations": "Lieblingsstationen ändern",
  "common.modifyFavoriteStationsDescription": "Sie können Ihre Lieblingsstationen neu bestellen, indem Sie sie ziehen. Sie können sie auch aus der Liste entfernen.",
  "common.moduleType": "Modultyp",
  "common.monthTotal": "Gesamter Monat",
  "common.more": "Mehr",
  "common.moreInformation": "Mehr Informationen",
  "common.myLocation": "Mein Standort",
  "common.nearbyWeatherStations": "Nahe gelegene Wetterstationen",
  "common.next": "Nächste",
  "common.nextHours": "Die nächsten Stunden",
  "common.no": "Nein",
  "common.noAccountNeeded": "Kein Konto erforderlich",
  "common.noDataForThisPeriod": "Keine Daten für den Zeitraum",
  "common.noLocationsFound": "Keine Orte gefunden",
  "common.noNetatmoWeatherStationYet": "Sie haben noch keinen Netatmo Wetterstation.",
  "common.noOutdoorModule": "Für diese Station gibt es kein funktionierendes Außenmodul.",
  "common.noStationsFound": "Keine Stationen gefunden",
  "common.noThermostatYet": "Sie haben noch keinen Netatmo Thermostat",
  "common.notNow": "Nicht jetzt",
  "common.notPurchasedYet": "Es scheint, dass es noch nicht gekauft wurde.",
  "common.noWeatherStation": "keine Wetterstation",
  "common.noWeatherStationYet": "Sie haben noch keine Wetterstation.",
  "common.numberOfActiveWarnings": "{warning_count} active Wetterwarnungen",
  "common.openSettings": "Einstellungen geöffnet",
  "common.orChooseMonthly": "Oder monatlich wählen:",
  "common.outdatedModule": "Die Daten für dieses Modul sind veraltet.",
  "common.outdoor": "Aussen",
  "common.outdoorTemperature": "Außentemperatur",
  "common.pageNotFound": "Seite Nicht Gefunden",
  "common.pageNotFoundDescription": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
  "common.passwordUpdated": "Passwort erfolgreich aktualisiert.",
  "common.personalWeatherIntelligence": "Ihre Persönliche Wetterintelligenz",
  "common.premiumAccount": "Premium-Konto",
  "common.premiumDescription": "Das Premium-Abonnement bietet eine Vielzahl zusätzlicher Funktionen wie erweiterte Wetteranalyse, Kartenvergleich, regionale Prognosemodelle und vieles mehr.",
  "common.premiumFeatureAlerts": "Wetterwarnungen",
  "common.premiumFeatureAnalysis": "Erweiterte Wetteranalyse",
  "common.premiumFeatureCharts": "Diagrammvergleiche",
  "common.premiumFeatureExport": "Datenexport",
  "common.premiumFeatureForecast": "Regionale Vorhersagemodelle",
  "common.premiumFeatureNotification": "Statusleisten-Widget",
  "common.premiumFeatureTitle": "Premium-Funktion",
  "common.premiumFeatureWidgets": "Startbildschirm-Widgets",
  "common.pressureSummary": "Luftdruck Zusammenfassung",
  "common.previous": "Vorherige",
  "common.previousHours": "Vorherige Stunden",
  "common.profileUpdated": "Profil erfolgreich aktualisiert.",
  "common.purchasedNetatmoPro": "Sie haben Netatmo Pro bereits gekauft ({date}). Abonnieren Sie eines der unten aufgeführten Angebote, um Zugriff auf alle Premium-Funktionen der Anwendung zu erhalten.",
  "common.radarDataAttribution": "Radardaten: RainViewer.com",
  "common.rain": "Regen",
  "common.rainEvents": "Regen Events",
  "common.rainfallMeasurement": "Niederschlagsmessung",
  "common.rainRadar": "Regenradar",
  "common.rainRadarDescription": "Regenradar-Overlay auf der Karte anzeigen",
  "common.rainSummary": "Regen Zusammenfassung",
  "common.range": "Spanne",
  "common.recentLocations": "Jüngste",
  "common.recentLocationsEmpty": "Ihre jüngste Geschichte ist leer.",
  "common.recentStations": "zuletzt verwendete Stationen",
  "common.relatedArticles": "Verwandte Artikel",
  "common.relay": "Relais",
  "common.removeFromFavorites": "von Favortiten entfernen",
  "common.renameSensors": "Sensoren umbenennen",
  "common.resetZoom": "Zoom zurücksetzen",
  "common.restorePurchase": "Kauf wiederherstellen",
  "common.room": "Raum",
  "common.rooms": "Räume",
  "common.savingsPercent": "Spare {percent}%",
  "common.searchArticles": "Artikel suchen...",
  "common.searchForALocation": "Nach einem Ort suchen...",
  "common.searchForLocation": "nach einem Standort suchen",
  "common.searchForWeatherStation": "nach einer Wetterstation suchen",
  "common.searchResults": "Suchergebnisse",
  "common.searchResultsEmpty": "Keine Ergebnisse gefunden.",
  "common.searchStationsDescription": "Geben Sie eine Stadt, Adresse oder einen Ortsnamen ein, um Wetterstationen in der Nähe zu finden.",
  "common.searchStationsHint": "Verwenden Sie die Suchleiste oben, um Wetterstationen an jedem Ort der Welt zu entdecken.",
  "common.selectStationForComparison": "Wähle eine Vergleichsstation",
  "common.selectWeatherForecastProvider": "Bitte wählen Sie einen Wetteranbieter",
  "common.serialNumber": "Seriennummer",
  "common.share": "Teilen",
  "common.shareOutdoorMeasures": "Teilen Sie Ihre Außenmessungen",
  "common.shareOutdoorMeasuresDescription": "Nehmen Sie an der SmartMixin Community teil, um Ihre Außenmessung amderem Teilnehmern sichtbar zu machen. Messungen der Innentemperatur werden niemals geteilt.",
  "common.shareYourWeather": "Aktuelles Wetter teilen",
  "common.signalStrength": "Signalstärke",
  "common.skip": "Überspringen",
  "common.smartThermostat": "Smart Thermostat",
  "common.smartValve": "Smart Valve",
  "common.snow": "Schnee",
  "common.start": "Start",
  "common.startFreeTrial": "Kostenlos testen",
  "common.startTime": "Startzeit",
  "common.station": "Station",
  "common.stationAddedToFavorites": "Station zu Favoriten hinzugefügt",
  "common.stationComparison": "Stationsvergleich",
  "common.stationComparisonDescription": "Vergleiche historische Daten mit anderer Station",
  "common.stationInformation": "Stationsinformationen",
  "common.stationName": "Stationsname",
  "common.stationObservationsDescription": "Zeigen Sie die neuesten Beobachtungen von Wetterstationen an",
  "common.stationRemovedFromFavorites": "Station aus Favoriten entfernt",
  "common.stations": "Stationen",
  "common.stationsNear": "Stationen in der Nähe von",
  "common.stationType": "Stationstyp",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Veraltet",
  "common.statusSyncing": "Synchronisierung",
  "common.subscribeNow": "Jetzt abonnieren - ohne Testphase",
  "common.sumOverThePeriod": "Über den Zeitraum kumuliert",
  "common.switchToPremium": "Zu SmartMixin Premium wechseln",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Temperatur Zusammenfassung",
  "common.thankYouForFeedback": "Vielen Dank für Ihr Feedback!",
  "common.thenPrice": "dann {price}",
  "common.timeSelection": "Zeitauswahl",
  "common.timezone": "Zeitzone",
  "common.totalDuration": "komplette Dauer",
  "common.tryAnotherLocation": "Wir konnten keine Wetterstationen in der Nähe dieses Ortes finden. Versuchen Sie, nach einem anderen Gebiet zu suchen.",
  "common.unknown": "Unbekannt",
  "common.untilChanged": "Bis zur Änderung",
  "common.untilTime": "Bis {time}",
  "common.upgrade": "Upgrade",
  "common.upgradeRequiredAndroid": "Ein Upgrade Ihrer Anwendung ist erforderlich. Prüfen Sie auf Updates bei Google Play.",
  "common.upgradeRequiredIos": "Ein Upgrade Ihrer Anwendung ist erforderlich. Prüfen Sie auf Updates im App Store.",
  "common.validate": "Validieren",
  "common.validEmail": "Eine gültige E-Mail-Adresse ist erforderlich.",
  "common.very_low": "Sehr niedrig",
  "common.visitNetatmoWebsite": "Netatmo Webseite",
  "common.wasArticleHelpful": "War dieser Artikel hilfreich?",
  "common.weatherCondition": "Wetterzustand",
  "common.weatherflowNCRain": "NC Rain (Nearcast rain)",
  "common.weatherflowNCRainDescription": "NC Rain ist eine zusätzliche Datenquelle, die über das Tempest Weather System bereitgestellt wird, das von Nearcast Technology unterstützt wird. Bei den NC rain handelt es sich um eine Schätzung der durchschnittlichen Niederschlagsansammlung rund um Ihren Sturm auf Nachbarschaftsebene",
  "common.weatherForecastModels": "Wettervorhersagen Modelle",
  "common.weatherIntelligencePlatform": "Die Wetterintelligenz-Plattform",
  "common.weatherMap": "Wetterkarte",
  "common.weatherMapMetaDescription": "SmartMixin bietet interaktive Wetterkarten und Regenradar für Wetterbedingungen weltweit.",
  "common.weatherObservations": "Wetterbeobachtungen",
  "common.weatherStation": "Wetterstation",
  "common.weatherStations": "Stationen",
  "common.welcome": "Willkommen bei SmartMixin!",
  "common.whenBackHome": "Wann bist du wieder zu Hause?",
  "common.wifiStrength": "WiFi-Stärke",
  "common.wind": "Wind",
  "common.windMeasurement": "Windmessung",
  "common.windSpeed": "Windgeschwindigkeit",
  "common.windSummary": "Wind Zusammenfassung",
  "common.yearToDate": "seit Jahresbeginn",
  "common.yes": "Ja",
  "intro.locationDescription": "Aktiviere den Standortzugriff für präzise Vorhersagen, die genau auf deinen Standort zugeschnitten sind — keine allgemeinen Wetterberichte mehr.",
  "intro.locationTitle": "Vorhersagen, die zu dir passen",
  "intro.notificationDescription": "Aktiviere Benachrichtigungen, um rechtzeitig über Wetteränderungen informiert zu werden — Regen, Schnee oder Unwetter, genau dann, wenn es zählt.",
  "intro.notificationsTitle": "Verpasse keinen Wetterumschwung",
  "intro.readyDescription": "Genieße präzise Vorhersagen, Live-Wetterdaten und weltweite Stationsinformationen — alles in einer leistungsstarken App.",
  "intro.readyTitle": "Alles bereit!",
  "intro.welcomeDescription": "Erhalte hyperlokale Vorhersagen von führenden Wetterdiensten — plus Zugriff auf über 40.000 Wetterstationen weltweit, um echte Bedingungen in Vergangenheit und Gegenwart zu sehen.",
  "intro.welcomeTitle": "Dein Wetter, neu gedacht",
  "landing.alerts": "Warnungen",
  "landing.alertsDescription": "Erstellen Sie Ihre eigenen Benachrichtigungen und werden Sie benachrichtigt, sobald sie ausgelöst werden.",
  "landing.featureAlertsDescription": "Legen Sie benutzerdefinierte Schwellenwerte für jeden Messwert fest. Werden Sie benachrichtigt, wenn die Temperatur sinkt, Regen beginnt oder Wind aufkommt.",
  "landing.featureAlertsTitle": "Intelligente Warnungen",
  "landing.featureAnalyticsDescription": "Interaktive Diagramme, Trendanalysen und detaillierte Statistiken. Tauchen Sie tief in Temperatur-, Feuchtigkeits-, Druck-, Regen- und Winddaten ein.",
  "landing.featureAnalyticsTitle": "Erweiterte Analysen",
  "landing.featureExportDescription": "Laden Sie Ihre Wetterdaten als CSV-Dateien herunter für weitere Analysen in Excel, Google Sheets oder Ihren Lieblingstools.",
  "landing.featureExportTitle": "Daten exportieren",
  "landing.featureForecastDescription": "Zugriff auf 10+ professionelle Vorhersagemodelle einschließlich ECMWF, GFS und regionale Modelle. Vergleichen Sie sie nebeneinander für Ihre eigenen Vorhersagen.",
  "landing.featureForecastTitle": "Vorhersagemodelle vergleichen",
  "landing.featureHistoryDescription": "Zugriff auf historische Daten mit stündlicher, täglicher und monatlicher Skala. Export als CSV für Forschung oder persönliche Archive.",
  "landing.featureHistoryTitle": "Umfangreiche Historie",
  "landing.featureMultiBrandDescription": "Verbinden Sie Netatmo, Davis, Tempest, Ecowitt, Ambient Weather und mehr. Kein App-Wechsel mehr nötig.",
  "landing.featureMultiBrandTitle": "Alle Marken, eine App",
  "landing.featuresSubtitle": "SmartMixin gibt Ihnen die Werkzeuge, um Ihre Wetterdaten wie ein Profi zu analysieren, vergleichen und verstehen.",
  "landing.featuresTitle": "Für Datenliebhaber gebaut",
  "landing.finalCtaButton": "Kostenloses Konto erstellen",
  "landing.finalCtaSubtitle": "Schließen Sie sich Tausenden von Wetterenthusiasten an, die SmartMixin vertrauen.",
  "landing.finalCtaTitle": "Bereit, tiefer in Ihre Wetterdaten einzutauchen?",
  "landing.forecastDescription": "Greifen Sie auf einige der besten Wettervorhersagemodelle zu und vergleichen Sie sie, um eine eigene Vorstellung davon zu bekommen, wie das Wetter sein wird.",
  "landing.forecasts": "Prognosen",
  "landing.heroCta": "Kostenlos starten",
  "landing.heroDescription": "Tiefgehende Analysen, schöne Diagramme und professionelle Vorhersagen — alle Ihre Wetterstationen in einer leistungsstarken App vereint.",
  "landing.heroSecondaryCta": "Karte erkunden",
  "landing.heroTagline": "Für Wetterenthusiasten",
  "landing.heroTitle": "Sehen Sie Ihr Wetter wie nie zuvor",
  "landing.pricingFeatureAdvancedMetrics": "Erweiterte Metriken",
  "landing.pricingFeatureAlerts": "Benutzerdefinierte Warnungen",
  "landing.pricingFeatureExport": "Datenexport (CSV)",
  "landing.pricingFeatureForecastComparison": "Vorhersagevergleich",
  "landing.pricingFeatureForecasts": "Vorhersagemodelle",
  "landing.pricingFeatureForecastsFreeTier": "1 Modell",
  "landing.pricingFeatureForecastsPremiumTier": "10+ Modelle",
  "landing.pricingFeatureReports": "Analysen & Berichte",
  "landing.pricingFeatureStationComparison": "Stationsvergleich",
  "landing.pricingFeatureWidgets": "Startbildschirm-Widgets",
  "landing.pricingFeatureYearOverYear": "Jahresvergleich",
  "landing.pricingFree": "Kostenlos",
  "landing.pricingFreeCta": "Loslegen",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Beliebteste",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Jetzt starten",
  "landing.pricingPremiumDescription": "Ab 1,99 €/Monat — abonnieren Sie im Web, App Store oder Google Play",
  "landing.pricingSubtitle": "Starten Sie kostenlos, upgraden Sie wenn Sie mehr Power brauchen.",
  "landing.pricingTitle": "Einfache, transparente Preise",
  "landing.smartMixinDescription": "SmartMixin ist eine Anwendung, die Zugriff auf Ihre Wetterstation und über 40.000 andere Stationen weltweit bietet. Es hilft Ihnen, Wetterdaten zu sehen und zu verstehen.",
  "landing.statBrands": "Unterstützte Marken",
  "landing.statForecasts": "Vorhersagemodelle",
  "landing.statStations": "Wetterstationen",
  "landing.supportedDevices": "Unterstützte Geräte",
  "landing.supportedDevicesDescription": "Zusätzlich zu den Stationen der Weltorganisation für Meteorologie unterstützt SmartMixin eine wachsende Zahl von Wetterstationsmarken.",
  "landing.supportedDevicesNote": "Plus 40.000+ öffentliche Stationen der Weltorganisation für Meteorologie",
  "landing.supportedDevicesSubtitle": "Verbinden Sie Ihre bestehende Wetterstation in wenigen Minuten. Wir unterstützen 8 große Marken und mehr.",
  "landing.supportedDevicesTitle": "Funktioniert mit Ihrer Station",
  "landing.thermostatDescription": "Verbinden Sie Ihren Netatmo-Thermostat, um Heizmuster mit Außenbedingungen zu korrelieren.",
  "landing.thermostatManufacturers": "Hersteller von Thermostaten werden auch dabei unterstützt, die Heizung mit den Außenbedingungen in Zusammenhang zu bringen.",
  "landing.thermostatTitle": "Smart-Home-Integration",
  "landing.weatherAnalysis": "Wetteranalyse",
  "landing.weatherAnalysisDescription": "SmartMix verfügt über zahlreiche Datenvisualisierungen, mit denen Sie Wetterdaten analysieren können.",
  "landing.weatherAssistant": "Ihr Wetterassistent",
  "landing.weatherAssistantDescription": "Unabhängig davon, ob Sie sich für aktuelle, historische oder prognostizierte Wetterbedingungen interessieren, SmartMixin bietet Ihnen zahlreiche Einblicke, wann immer Sie diese benötigen.",
  "landing.weatherForecastModels": "Wettervorhersagemodelle",
  "landing.weatherForecastModelsDescription": "SmartMixin bietet Zugriff auf die genauesten Wettervorhersagemodelle. Sie können ihre Prognosen ganz einfach vergleichen und sich Ihre eigene Vorstellung machen.",
  "landing.weatherMap": "Wetterkarte",
  "landing.weatherMapDescription": "Durchsuchen Sie die Karte und visualisieren Sie das Wetter überall auf der Welt.",
  "network.cancelError": "Anfrage wurde storniert",
  "network.connectionError": "Server nicht verfügbar",
  "network.networkError": "Netzwerk nicht verfügbar",
  "network.serverError": "Es gab ein Problem...",
  "network.timeoutError": "Verbindungszeitüberschreitung",
  "network.unknownError": "Unbekannter Fehler",
  "providerHints.ambientWeatherApiKey": "In den Kontoeinstellungen von ambientweather.net erstellt.",
  "providerHints.davisApiSecret": "Wird nur einmal beim Erstellen des V2-API-Schlüssels angezeigt — sicher aufbewahren.",
  "providerHints.davisV2ApiKey": "Von der V2-API-Schlüsselseite auf weatherlink.com.",
  "providerHints.ecowittApi": "Von der API-Seite Ihres Ecowitt-Kontos.",
  "providerHints.ecowittApp": "Der Anwendungs-Schlüssel, ebenfalls aus Ihrem Ecowitt-Konto.",
  "providerHints.myAcuriteCredentialsBanner": "Verwenden Sie E-Mail und Passwort Ihres My AcuRite-Kontos — nicht Ihren SmartMixin-Login.",
  "providerHints.myAcuriteEmail": "Die E-Mail-Adresse Ihres My AcuRite-Kontos — nicht Ihr SmartMixin-Login.",
  "providerHints.myAcuritePassword": "Das Passwort Ihres My AcuRite-Kontos.",
  "providerHints.weatherflowToken": "Persönlicher Token von tempestwx.com → Einstellungen → Datenautorisierungen.",
  "providerHints.wundergroundEditKey": "Anderen Schlüssel verwenden",
  "providerHints.wundergroundKey": "Eine lange Zeichenfolge von Ihrer Weather Underground API-Schlüssel-Seite — nicht Ihr wunderground.com-Passwort.",
  "providerHints.wundergroundKeyExample": "z. B. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-Schlüssel verifiziert",
  "providerHints.wundergroundKeyVerifying": "Schlüssel wird geprüft…",
  "providerHints.wundergroundNoStationsNearby": "Keine Stationen in der Nähe gefunden. Versuchen Sie, direkt eine Stations-ID einzugeben.",
  "providerHints.wundergroundStationId": "Eine beliebige Weather Underground Stations-ID — Ihre eigene oder eine öffentliche Station in Ihrer Nähe.",
  "providerHints.wundergroundStationIdExample": "z. B. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Holen Sie Ihren Ambient Weather API-Schlüssel.",
  "providerIntro.davisStep2": "Holen Sie Ihren Davis V2-API-Schlüssel und API-Secret.",
  "providerIntro.ecowittStep2": "Holen Sie Ihren Ecowitt API- und Anwendungs-Schlüssel.",
  "providerIntro.getStarted": "Loslegen",
  "providerIntro.myAcuriteStep2": "Verwenden Sie E-Mail und Passwort Ihres bestehenden My AcuRite-Kontos.",
  "providerIntro.netatmoEnergyStep2": "Bei Aufforderung bei Netatmo anmelden — kein API-Schlüssel erforderlich.",
  "providerIntro.netatmoWeatherStep2": "Bei Aufforderung bei Netatmo anmelden — kein API-Schlüssel erforderlich.",
  "providerIntro.signupBanner": "Fast geschafft — erstellen Sie Ihr kostenloses SmartMixin-Konto, um {provider} zu verbinden.",
  "providerIntro.step1": "Melden Sie sich bei Ihrem SmartMixin-Konto an (NICHT Ihr {provider}-Login).",
  "providerIntro.step3EmailPassword": "Hier eingeben.",
  "providerIntro.step3KeyOrToken": "Hier einfügen.",
  "providerIntro.step3OAuth": "Autorisieren Sie SmartMixin im Popup-Fenster.",
  "providerIntro.step3Wunderground": "Fügen Sie Ihren API-Schlüssel ein und wählen Sie dann eine Station in der Nähe oder geben Sie eine beliebige Stations-ID ein.",
  "providerIntro.title": "{provider} verbinden",
  "providerIntro.weatherflowStep2": "Holen Sie Ihren Tempest-Token zur persönlichen Nutzung.",
  "providerIntro.wundergroundBrowsePublic": "Keine Station? Öffentliche Stationen durchsuchen",
  "providerIntro.wundergroundFindNearby": "Stationen in meiner Nähe finden",
  "providerIntro.wundergroundOrEnterId": "Oder Stations-ID eingeben",
  "providerIntro.wundergroundStep2": "Holen Sie Ihren Weather Underground API-Schlüssel. Sie können dann jede beliebige Station verbinden — Ihre eigene oder eine öffentliche.",
  "reports.agroMeteorology": "Agrarmeteorologie",
  "reports.analysis": "Analyse",
  "reports.annualCumulativeRainfallComparison": "Vergleich jährlich kumulierter Niederschlag",
  "reports.annualHeatingDurationComparison": "Jährlicher Vergleich der Heizdauer",
  "reports.annualHeatingEfficiency": "Jährliche Heiz-Effizienz",
  "reports.annualIndoorComparison": "Jahresweiser Innenvergleich",
  "reports.annualIndoorReport": "Jahresweiser Innenbericht",
  "reports.annualOutdoorComparison": "Jahresweiser Außenvergleich",
  "reports.annualOutdoorReport": "Jahresweiser Außenbericht",
  "reports.annualReport": "Jahresbericht",
  "reports.annualSolarReport": "Jährlicher Solarbericht",
  "reports.annualWaterBalance": "Jährliche Wasserbilanz",
  "reports.annualWaterBalanceCarryOver": "Vorjahr übernehmen",
  "reports.annualWaterBalanceDescription": "Wasserbilanz",
  "reports.avgHumidity": "Durchschn. Feuchtigkeit",
  "reports.avgMaxTemperature": "Durchschn. T°max",
  "reports.avgMinTemperature": "Durchschn. T°min",
  "reports.avgPressure": "durchschn. Luftdruck",
  "reports.avgTemperature": "Durchschnittstemperatur",
  "reports.comfortable": "Komfortabel (45% {lessThan} Luftfeuchtigkeit ≤ 60%)",
  "reports.cumulativeRainfall": "Kumulierter Niederschlag",
  "reports.cumulativeRainfallDescription": "Verfolgen Sie die Gesamtniederschlagsmenge, die sich über den gewählten Zeitraum ansammelt.",
  "reports.dailyMaxRainfall": "Täglich Max Niederschlag",
  "reports.dataExport": "Datenexport",
  "reports.dataExportXlsxFormatDescription": "Exportieren Sie alle Daten Ihrer Station im Excel-Format (* .xlsx). Sobald Sie auf den Button klicken, erhalten Sie nach einigen Minuten eine EMail mit den verarbeiteten Daten.",
  "reports.daysWithFrost": "Tage mit Frost",
  "reports.daysWithoutThaw": "Tage mit Dauerfrost",
  "reports.daysWithStrongFrost": "Tage mit starkem Frost",
  "reports.emailSent": "Eine EMail wurde an Sie gesendet",
  "reports.grasslandTemperatureSum": "Grünland-Temperatur-Summe",
  "reports.grasslandTemperatureSumDescription": "Wird im Frühjahr die Summe von {threshold} überschritten, ist damit der nachhaltige Vegetationsbeginn erreicht",
  "reports.growingDegreeDays": "Wachstumsgradtage",
  "reports.highPressure": "Hochdruck (Durchschnittsdruck ≥ 1013 mbar)",
  "reports.indoorReport": "Innenbericht",
  "reports.keyFacts": "Schlüsselwerte",
  "reports.longestRunOfRainyDays": "Längste Dauer Regentage",
  "reports.longestRunWithoutRun": "Längste Dauer Trockenheit",
  "reports.lowPressure": "Tiefdruck {lessThan} 1013 mbar",
  "reports.maxHumidity": "Maximum Luftfeuchtigkeit",
  "reports.maxPressure": "höchster Luftdruck",
  "reports.maxPressureMagnitude24h": "höchster Wert (/24H)",
  "reports.maxTemperature": "Maximaltemperatur",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "höchster Wert (/24H)",
  "reports.minHumidity": "Minimum Feuchtigkeit",
  "reports.minPressure": "niedrigster Luftdruck",
  "reports.minPressureMagnitude24h": "niedrigster Wert (/24H)",
  "reports.minTemperature": "Minimaltemperatur",
  "reports.minTempMagnitude24h": "niedrigster Wert (/24H)",
  "reports.monthlyHeatingEfficiency": "monatliche Heiz-Effizienz",
  "reports.monthlyIndoorReport": "Monatsweiser Innenbericht",
  "reports.monthlyOutdoorReport": "Monatsweiser Außenbericht",
  "reports.monthlyReport": "Monatlicher Bericht",
  "reports.monthlySolarReport": "Monatlicher Solarbericht",
  "reports.monthlyWindReport": "Monatlicher Windbericht",
  "reports.numberOfDays": "Anzahl der Tage",
  "reports.outdoorReport": "Außen-Bericht",
  "reports.rainfall": "Niederschlag",
  "reports.rainyDays": "Regentage",
  "reports.relativelyWet": "höhere Luftfeuchtigkeit (60% {lessThan} Luftfeuchtigkeit ≤ 80%)",
  "reports.sendEmail": "EMail senden",
  "reports.tooDry": "zu trocken (Luftfeuchtigkeit ≤ 45%)",
  "reports.tooWet": "zu feucht (Luftfeuchtigkeit {greaterThan} 80%)",
  "reports.tropicalNights": "Tropische Nächte",
  "reports.waterBalance": "Wasserbilanz",
  "reports.yearToDateTemperature": "Temperatur seit Jahresbeginn",
  "reports.yearToDateTemperatureComparison": "Temperaturvergleich seit Jahresbeginn",
  "sensors.aqiByChannel": "AQI nach Kanal",
  "sensors.bgtSensors": "Schwarzkugel & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareAqi": "AQI vergleichen",
  "sensors.compareHumidity": "Luftfeuchtigkeit vergleichen",
  "sensors.compareMoisture": "Bodenfeuchtigkeit vergleichen",
  "sensors.comparePm25": "PM2.5 vergleichen",
  "sensors.compareTemperatures": "Temperaturen vergleichen",
  "sensors.depthByChannel": "Tiefe nach Kanal",
  "sensors.heatStressExtreme": "Extremer Hitzestress",
  "sensors.heatStressModerate": "Mäßiger Hitzestress",
  "sensors.heatStressNone": "Kein Hitzestress",
  "sensors.heatStressStrong": "Starker Hitzestress",
  "sensors.heatStressVeryStrong": "Sehr starker Hitzestress",
  "sensors.humidityByChannel": "Luftfeuchtigkeit nach Kanal",
  "sensors.indoorAirQuality": "Luftqualität innen",
  "sensors.indoorAirQualityPm": "PM2.5 & PM10 AQI",
  "sensors.indoorClimate": "Raumklima",
  "sensors.indoorCo2Levels": "CO2-Werte",
  "sensors.indoorTemperatureAndHumidity": "Temperatur & Luftfeuchtigkeit",
  "sensors.last24Hours": "24 Stunden",
  "sensors.last30Days": "30 Tage",
  "sensors.last7Days": "7 Tage",
  "sensors.leafTemperatureByChannel": "Blatttemperatur nach Kanal",
  "sensors.leafWetnessByChannel": "Blattfeuchte nach Kanal",
  "sensors.lightningSensor": "Blitz",
  "sensors.moistureByChannel": "Bodenfeuchtigkeit nach Kanal",
  "sensors.noDataAvailable": "Keine Daten verfügbar",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 nach Kanal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Kanal auswählen",
  "sensors.sensorDetailDescription": "Historische Daten und Trends für Ihre Sensorkanäle anzeigen.",
  "sensors.sensorHistory": "Sensorverlauf",
  "sensors.soilConductivityByChannel": "Leitfähigkeit nach Kanal",
  "sensors.soilTemperatureByChannel": "Bodentemperatur nach Kanal",
  "sensors.strikesToday": "Einschläge heute",
  "sensors.temperatureByChannel": "Temperatur nach Kanal",
  "settings.about": "Über",
  "settings.aboutDescription": "Lizenzvereinbarung, Datenschutzrichtlinie",
  "settings.account": "Konto",
  "settings.accountDescription": "Profil, Passwortänderung",
  "settings.accountIntro": "Ihre Kontoinformationen:",
  "settings.accountSection": "Konto",
  "settings.appearance": "Erscheinungsbild",
  "settings.appearanceDescription": "Design und Anzeigeoptionen",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arabisch",
  "settings.availableServices": "Verfügbar",
  "settings.bulgarian": "Bulgarisch",
  "settings.cannotDisconnectLastAccount": "Ihre einzige Anmeldemethode kann nicht getrennt werden. Bitte fügen Sie zuerst eine andere Anmeldemethode hinzu.",
  "settings.changeEmail": "E-Mail ändern",
  "settings.changePassword": "Passwort ändern",
  "settings.chartGestures": "Gesten auf Diagrammen",
  "settings.chartGesturesDescription": "Durch Wischen in Diagrammen wird der Zeitraum geändert, durch Einklemmen von Diagrammen wird die Zeitskala geändert",
  "settings.connect": "Verbinden",
  "settings.connected": "Verbunden",
  "settings.connectedAccounts": "Verknüpfte Konten",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Verbunden",
  "settings.connectedSince": "Verbunden seit {date}",
  "settings.connectionSuccess": "{provider}-Konto erfolgreich verbunden",
  "settings.contactUs": "Kontakt",
  "settings.contactUsDescription": "Hilfe erhalten oder Feedback senden",
  "settings.croatian": "Kroatisch",
  "settings.currentPassword": "Aktuelles Passwort",
  "settings.czech": "Tschechisch",
  "settings.danish": "Dänisch",
  "settings.dark": "Dunkle Darstellung",
  "settings.dataDisplay": "Datenanzeige",
  "settings.dateAndTime": "Datum und Uhrzeit",
  "settings.disconnect": "Trennen",
  "settings.disconnectConfirmation": "Möchten Sie Ihr {provider}-Konto wirklich trennen?",
  "settings.disconnectionSuccess": "{provider}-Konto erfolgreich getrennt",
  "settings.donateButton": "Spenden",
  "settings.donateDescription": "SmartMixin wird von einem kleinen Team entwickelt. Wenn es Ihnen nützlich ist, können Sie die Entwicklung mit einer einmaligen Spende in beliebiger Höhe unterstützen. Es ist ein Geschenk — es ändert Ihren Tarif nicht und schaltet keine Funktionen frei.",
  "settings.donateSuccessBody": "Ihre Spende hilft dabei, SmartMixin am Laufen zu halten und weiter zu verbessern. Wir wissen das sehr zu schätzen.",
  "settings.donateSuccessTitle": "Vielen Dank für Ihre Unterstützung!",
  "settings.donateTitle": "SmartMixin unterstützen",
  "settings.dutch": "Niederländisch",
  "settings.emailChange": "E-Mail-Adresse ändern",
  "settings.emailChangeConfirmation": "Bestätigung der E-Mail-Änderung",
  "settings.emailChangeFailure": "Der Link zur E-Mail-Änderung ist ungültig oder abgelaufen.",
  "settings.emailChangeSuccess": "Ihre E-Mail-Adresse wurde erfolgreich zu {newEmail} geändert.",
  "settings.emailChangeVerificationSent": "Eine Bestätigungs-E-Mail wurde an Ihre neue E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den Link, um die Änderung zu bestätigen.",
  "settings.english": "Englisch",
  "settings.forecastModelOrderEmpty": "Keine Reihenfolge gespeichert — wir verwenden standardmäßig GFS.",
  "settings.forecastModelOrderFreeHint": "Premium-Modelle erfordern ein SmartMixin Premium-Abonnement.",
  "settings.forecastModelOrderHelp": "Wir wählen das erste Modell aus Ihrer Liste, das die jeweilige Station abdeckt.",
  "settings.forecastModelOrderReset": "Auf Standard zurücksetzen",
  "settings.forecastModelOrderTitle": "Standard-Vorhersagemodell",
  "settings.forecastModels": "Vorhersagemodelle",
  "settings.forecastModelsDescription": "Nach Präferenz sortieren",
  "settings.french": "Französisch",
  "settings.german": "Deutsch",
  "settings.gestures": "Gesten",
  "settings.greek": "griechisch",
  "settings.helpCenter": "Hilfecenter",
  "settings.helpCenterDescription": "FAQs und Anleitungen",
  "settings.hungarian": "Ungarisch",
  "settings.integrationsSection": "Integrationen",
  "settings.italian": "Italienisch",
  "settings.japanese": "Japanisch",
  "settings.korean": "Koreanisch",
  "settings.language": "Sprache",
  "settings.languageDescription": "Bevorzugte Sprache",
  "settings.light": "Helle Darstellung",
  "settings.newEmailAddress": "Neue E-Mail-Adresse",
  "settings.newPassword": "Neues Passwort",
  "settings.newPasswordAgain": "Neues Passwort (wiederholen)",
  "settings.norwegian": "Norwegisch",
  "settings.notConnected": "Nicht verbunden",
  "settings.notificationsSection": "Benachrichtigungen",
  "settings.oldPassword": "Altes Passwort",
  "settings.ongoingNotificationEnabled": "Dauerhafte Benachrichtigung aktivieren",
  "settings.ongoingNotificationMetrics": "Angezeigte Messwerte",
  "settings.ongoingNotificationMetricsHint": "Ziehen zum Neuanordnen der ausgewählten Messwerte",
  "settings.ongoingNotificationPermissionRequired": "Benachrichtigungsberechtigung erforderlich",
  "settings.ongoingNotificationStation": "Wetterstation",
  "settings.passwordChange": "Passwortänderung",
  "settings.polish": "Polnisch",
  "settings.portuguese": "Portugiesisch",
  "settings.preferencesSection": "Einstellungen",
  "settings.premium": "Premium",
  "settings.premiumActive": "Aktiv",
  "settings.premiumAnnualThenPrice": "Dann 9,99 €/Jahr",
  "settings.premiumAnnualTrialInfo": "Starten Sie mit einer kostenlosen {days}-Tage-Testphase",
  "settings.premiumCurrentPlan": "Aktueller Plan",
  "settings.premiumDescription": "Premium-Funktionen freischalten",
  "settings.premiumDownloadApp": "Laden Sie die App herunter, um zu abonnieren:",
  "settings.premiumExpiresOn": "Verlängert am {date}",
  "settings.premiumFreePlan": "Kostenlos",
  "settings.premiumInactive": "Kein Abonnement",
  "settings.premiumManageWebSubscription": "Verwalten Sie Ihr Abonnement, aktualisieren Sie die Zahlungsmethode oder kündigen Sie.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Jährlich — 9,99 €/Jahr",
  "settings.premiumSubscribedOn": "Abonniert auf {platform}",
  "settings.premiumSubscribeMonthly": "Monatlich — 1,99 €/Monat",
  "settings.premiumSubscribeOnWeb": "Jetzt abonnieren, um alle Premium-Funktionen freizuschalten.",
  "settings.premiumSubscriptionSuccess": "Ihr Abonnement wurde aktiviert! Genießen Sie alle Premium-Funktionen.",
  "settings.premiumSubscriptionSuccessTitle": "Willkommen bei Premium!",
  "settings.premiumWebappNotice": "Abonnements können nur über die SmartMixin-App auf iOS oder Android erworben werden.",
  "settings.privacyPolicy": "Datenschutzerklärung",
  "settings.profile": "Profil",
  "settings.russian": "Russisch",
  "settings.serbian": "Serbisch",
  "settings.settings": "Einstellungen",
  "settings.slovak": "Slowakisch",
  "settings.smallDecimals": "Kleine Dezimalstellen",
  "settings.smallDecimalsDescription": "Dezimalziffern in kleinerer Größe anzeigen",
  "settings.socialConnectionsIntro": "Verknüpfen Sie Ihre sozialen Konten für eine schnelle Anmeldung. Sie können Konten jederzeit verbinden oder trennen.",
  "settings.spanish": "Spanisch",
  "settings.statusBarWidget": "Statusleisten-Widget",
  "settings.statusBarWidgetDescription": "Immer sichtbare Wetterdaten",
  "settings.subscriptionSection": "Abonnement",
  "settings.supportSection": "Support",
  "settings.swedish": "Schwedisch",
  "settings.systemTheme": "System Darstellung",
  "settings.termsOfService": "Nutzungsbedingungen",
  "settings.turkish": "Türkisch",
  "settings.ukrainian": "Ukrainisch",
  "settings.units": "Einheiten",
  "settings.unitsDescription": "In der Anwendung angezeigte Maßeinheiten",
  "settings.update": "Aktualisieren",
  "settings.updateYourProfile": "Profil-Aktualisierung",
  "settings.weatherServices": "Wetterdienste",
  "settings.weatherServicesConnected": "{count, plural, =0 {Keine Dienste verbunden} one {# Dienst verbunden} other {# Dienste verbunden}}",
  "settings.weatherServicesDescription": "Netatmo, Davis, Weatherflow und mehr verbinden",
  "settings.windDirectionConvention": "Windrichtungspfeil",
  "settings.windDirectionConventionDescription": "Anzeige der Windrichtungspfeile wählen",
  "settings.windDirectionMeteorological": "Ursprungsrichtung",
  "settings.windDirectionMeteorologicalDescription": "Pfeil zeigt, woher der Wind kommt (meteorological convention)",
  "settings.windDirectionOceanographic": "Strömungsrichtung",
  "settings.windDirectionOceanographicDescription": "Pfeil zeigt, wohin der Wind weht (oceanographic convention)",
  "units.absolutePressure": "Absoluter Luftdruck",
  "units.airDensity": "Luftdichte",
  "units.airGap": "Luftabstand",
  "units.apparentTemperature": "Gefühlte Temperatur",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "avg.",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Schwarzkugeltemperatur",
  "units.boilerOn": "Heizung EIN",
  "units.co2": "CO2",
  "units.conductivity": "Leitfähigkeit",
  "units.coolingDegreeDays": "CDD",
  "units.dailyHeatingDuration": "tägliche Heizdauer",
  "units.dailyPrecipitation": "Tagesniederschlag",
  "units.dailyRain": "Tagesregen",
  "units.degreeDay": "Tagestemperatur",
  "units.degreeDayShort": "TT",
  "units.depth": "Tiefe",
  "units.depthSensors": "Tiefensensoren",
  "units.dewPoint": "Taupunkt",
  "units.distance": "Entfernung",
  "units.downTrend": "sinkend",
  "units.E": "O",
  "units.E_long": "Ost",
  "units.ENE": "ONO",
  "units.ENE_long": "Ost-Nord-Ost",
  "units.ESE": "OSO",
  "units.ESE_long": "Ost-Süd-Ost",
  "units.ET": "Gesamtverdunstung (ET)",
  "units.ETshort": "ET",
  "units.feelLike": "gef. Temp.",
  "units.feelsLike": "gef. Temp.",
  "units.footMile": "Fuß, Meile",
  "units.frostPoint": "Gefrierpunkt",
  "units.gust": "Böe",
  "units.heatIndex": "Hitze-Index",
  "units.heatingDegreeDays": "Heiztage",
  "units.heatingPower": "Heizleistung",
  "units.humidex": "Humidex",
  "units.humidity": "Luftfeuchtigkeit",
  "units.inch": "Zoll",
  "units.inchOfMercury": "Zoll Quecksilber",
  "units.kilometerPerHour": "Kilometer pro Stunde",
  "units.knot": "Knoten",
  "units.last12Hours": "Letzte 12 Stunden",
  "units.last24Hours": "Letzte 24 Stunden",
  "units.last3Hours": "Letzte 3 Stunden",
  "units.last6Hours": "Letzte 6 Stunden",
  "units.lastHour": "Letzte Stunde",
  "units.lastLightningImpact": "Letzter Aufprall",
  "units.lastMeasure": "Letzte Messung",
  "units.leafSensors": "Feuchtigkeitssensoren",
  "units.leafWetness": "Blattnässe",
  "units.lightningDistance": "Entfernung",
  "units.lightningStrikeCount": "Anzahl der Blitzeinschläge",
  "units.lightningStrikeDistance": "Blitzeinschlag Entfernung",
  "units.max": "Max.",
  "units.max_gust": "Max. Böe",
  "units.max_wind": "Max. Wind",
  "units.meterKilometer": "Meter, Kilometer",
  "units.meterPerSecond": "Meter pro Sekunde",
  "units.milePerHour": "Meile pro Stunde",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimeter",
  "units.millimeterOfMercury": "Millimeter Quecksilber",
  "units.min": "Min.",
  "units.N": "N",
  "units.N_long": "Nord",
  "units.NE": "NO",
  "units.NE_long": "Nord-Ost",
  "units.NNE": "NNO",
  "units.NNE_long": "Nord-Nord-Ost",
  "units.NNW": "NNW",
  "units.NNW_long": "Nord-Nord-West",
  "units.noise": "Lautstärke",
  "units.normalizedHeatingCoefficient": "normierter Heizkoeffizient",
  "units.NW": "NW",
  "units.NW_long": "Nord-West",
  "units.O3": "Ozon",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2,5",
  "units.precipitation": "Niederschlag",
  "units.pressure": "Druck",
  "units.rain": "Regen",
  "units.rainRate": "Regenrate",
  "units.referenceTemperature": "Referenztemperatur",
  "units.relativePressure": "Relativer Druck",
  "units.S": "S",
  "units.S_long": "Süd",
  "units.SE": "SO",
  "units.SE_long": "Süd-Ost",
  "units.setPoint": "Sollwert",
  "units.snow": "Schnee",
  "units.snowfall": "Schneefall",
  "units.soilMoisture": "Feuchtigkeit",
  "units.soilSensors": "Bodensensor",
  "units.solarEnergy": "Sonnenenergie",
  "units.solarRadiation": "Sonnenstrahlung",
  "units.speed": "Geschwindigkeit",
  "units.SSE": "SSO",
  "units.SSE_long": "Süd-Süd-Ost",
  "units.SSW": "SSW",
  "units.SSW_long": "Süd-Süd-West",
  "units.stableTrend": "Stabil",
  "units.sum": "Sum",
  "units.SW": "SW",
  "units.SW_long": "Süd-West",
  "units.temperature": "Temperatur",
  "units.temperatureAndHumiditySensors": "Temperatur & Feuchtigkeits-Sensoren",
  "units.temperatureSensors": "Temperatur & Feuchtigkeits-Sensoren",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Heute",
  "units.upTrend": "steigend",
  "units.uv": "UV",
  "units.visibility": "Sichtbarkeit",
  "units.W": "W",
  "units.W_long": "West",
  "units.wetBulbGlobeTemperature": "Feuchtkugelglobetemperatur",
  "units.wetBulbTemperature": "Feuchtkugeltemperatur.",
  "units.wind": "Wind",
  "units.windChill": "Windchill",
  "units.windDirection": "Windrichtung",
  "units.windRun": "Verlauf des Windes",
  "units.windRunDescription": "Unter Windweg versteht man die Gesamtstrecke, die der Wind über einen bestimmten Zeitraum zurücklegt",
  "units.WNW": "WNW",
  "units.WNW_long": "West-Nord-West",
  "units.WSW": "WSW",
  "units.WSW_long": "West-Süd-West"
}
